<template>
  <span v-if="transable">
    <template v-if="value.trans">
      {{ $t(value.trans) }}
    </template>
    <span v-else>
      <template v-if="typeof value.text === 'object'">
        {{ value.text[$i18n.locale] || value.text[$i18n.fallbackLocale] }}
      </template>
      <template v-else>
        {{ value.text || value.name }}
      </template>
    </span>
  </span>
  <span v-else>
    <template v-if="typeof value === 'object'">
      {{ value[$i18n.locale] || value[$i18n.fallbackLocale] }}
    </template>
    <template v-else> {{ value }} </template>
  </span>
</template>

<script>
export default {
  props: {
    transable: Boolean,
    value: {
      default: () => ({}),
    },
  },
}
</script>

<style scoped></style>
